module.exports = __webpack_public_path__ + "assets/37358ce5e231318648b2cdec53293a27.jpg";